import breadCrumbComponent from './breadCrumb'

export default (Vue) => {
    Vue.component(breadCrumbComponent.name, breadCrumbComponent)
}